import { Component, Input } from '@angular/core';

import { DeliveryItemCardComponent } from './delivery-item-card/delivery-item-card.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DeliveryItemsCardHeaderComponent } from './delivery-items-card-header/delivery-items-card-header.component';
import { Order, OrderLine } from '../../../../graphql/generated/generated-types';

@Component({
  selector: 'app-delivery-items-card-list',
  standalone: true,
  imports: [DeliveryItemCardComponent, ButtonModule, RippleModule, DeliveryItemsCardHeaderComponent],
  templateUrl: './delivery-items-card-list.component.html',
  styleUrl: './delivery-items-card-list.component.scss'
})
export class DeliveryItemsCardListComponent {
  @Input() orderLines: OrderLine[];
  @Input() first!: boolean;
  @Input() inOrder!: boolean;
  @Input() inCart!: boolean;
  @Input() order: Order;

 
}
